/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext, useState } from 'react'
import { useMutation } from 'react-query'
import { Modal, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { AiFillCheckCircle } from 'react-icons/ai'
import { MdLink, MdCloudUpload } from 'react-icons/md'
import Loader from 'react-loader-spinner'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import Dropzone from 'react-dropzone'

import toast from 'react-hot-toast'
import * as s from './UploadResume.styles'
import './UploadResume.css'
import { isEmptyObject } from '../../../../../../utils/utils'
import { FeathersContext } from '../../../../../../services/feathers'
import { setResume } from '../../../../../../redux/reducers/talentSlice'
import AuthTalent from '../../../../../../services/AuthTalent'

const propTypes = {
  required: PropTypes.bool,
  showLabel: PropTypes.bool,
}
const defaultProps = {
  required: false,
  showLabel: true,
}

/**
 * Allows user create and set his own skills
 */
function UploadResume({ showLabel }) {
  const talent = useSelector((state) => state.talent)
  const { t } = useTranslation(['common', 'talentArea'], {
    useSuspense: false,
  })

  const feathers = useContext(FeathersContext)
  const dispatch = useDispatch()

  const [visible, setVisible] = useState(false)

  const uploadResume = useMutation(
    (files) => {
      const formData = new FormData()

      formData.append('uri', files[0])
      formData.append('name', files[0].name)
      formData.append('type', 'resume')
      formData.append('talentId', talent.id)

      return AuthTalent.fetch('/lambda-candidate-file', {
        method: 'POST',
        body: formData,
      })
    },
    {
      onMutate: () => {
        const toastId = toast.loading('loading')
        return toastId
      },
      onError: (error, _, context) => {
        console.error(error)
        toast.dismiss(context)
        toast.error(t('common:toasts.error'))
      },
      onSuccess: (data, _, context) => {
        dispatch(setResume(data))
        toast.dismiss(context)
        toast.success(t('common:toast.success.modify'))
        setVisible(false)
      },
    },
  )

  const sendMagicLink = useMutation(
    () =>
      feathers.service('lambda-talent').create({
        action: 'magicLink',
        candidateId: talent.id,
      }),
    {
      onMutate: () => {
        const toastId = toast.loading('loading')
        return toastId
      },
      onError: (error, _, context) => {
        console.error(error)
        toast.dismiss(context)
        toast.error(t('common:toasts.error'))
      },
      onSuccess: (_, __, context) => {
        toast.dismiss(context)
        toast.success(t('common:sent'))
        setVisible(false)
      },
    },
  )

  return (
    <s.UploadResumeWrapper>
      <div className="dropzone-wrapper dropzone-mail-attachments">
        <div className="container-upload">
          {uploadResume.isLoading && (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Loader type="Grid" color="#1890ff" height={40} width={40} />
            </div>
          )}
          {!isEmptyObject(talent?.resume) && !uploadResume.isLoading && (
            <div className="resume-uploaded">
              <AiFillCheckCircle color="#02CD9A" size={64} />
              {t('talentArea:profile.uploadResume.uploadedResume')}
            </div>
          )}
          <Button
            className={showLabel ? 'white-btn' : 'red-btn'}
            onClick={() => setVisible(true)}
          >
            {!uploadResume.isLoading && (
              <span>
                {talent.resume
                  ? t('talentArea:profile.replaceResume')
                  : t('talentArea:profile.addResume')}
              </span>
            )}
          </Button>
          <Modal
            visible={visible}
            footer={null}
            onCancel={() => setVisible(false)}
            className="resume-upload-modal"
            closable={false}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Button
                style={{
                  height: '100px',
                  margin: '10px',
                  borderRadius: '10px',
                  backgroundColor: 'var(--primary)',
                  color: 'white',
                  border: 'none',
                }}
              >
                <Dropzone onDrop={uploadResume.mutate} multiple={false}>
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()}>
                      <input
                        type="file"
                        accept=".jpg, .jpeg, .doc, .docx, .pdf"
                        data-testid="drop-input"
                        {...getInputProps()}
                      />
                      <div
                        className="dropzone-content"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <MdCloudUpload size={24} />

                        <strong>
                          {t('talentArea:profile.uploadResumeNow')}
                        </strong>
                        {t('talentArea:magic.supportedFiles')}
                      </div>
                    </div>
                  )}
                </Dropzone>
              </Button>
              <Button
                onClick={sendMagicLink.mutate}
                style={{
                  height: '100px',
                  margin: '10px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '10px',
                  backgroundColor: 'var(--primary)',
                  color: 'white',
                  border: 'none',
                }}
              >
                <MdLink size={24} />
                <strong>{t('talentArea:profile.receiveMagicLink')}</strong>
              </Button>
            </div>
          </Modal>
        </div>
      </div>
    </s.UploadResumeWrapper>
  )
}

UploadResume.propTypes = propTypes
UploadResume.defaultProps = defaultProps

export default UploadResume
